// Source de vérité centrale pour les dimensions d'images recommandées côté backoffice.
// Utilisée par ImageDimensionHint et les composants d'upload pour afficher une
// recommandation cohérente à l'admin. Les valeurs sont indicatives (recommandées),
// pas une validation stricte côté API.

export type ImageEntityKey =
  | 'sliderHero'
  | 'sliderThumb'
  | 'hotelGalleryLarge'
  | 'hotelGalleryThumb'
  | 'hotelCover'
  | 'pageHero'
  | 'cmsService'
  | 'facility'
  | 'userAvatar'
  | 'footerBackground'
  | 'headerImage'
  | 'aboutSection'

export interface ImageDimension {
  width: number
  height: number
  note?: string
  // Ratio cible (largeur/hauteur) pour un éventuel crop futur
  ratio?: number
}

export const IMAGE_DIMENSIONS: Record<ImageEntityKey, ImageDimension> = {
  sliderHero: { width: 1920, height: 512, note: 'Hero slider — min. 1200 px de large', ratio: 1920 / 512 },
  sliderThumb: { width: 600, height: 400, note: 'Vignette slider', ratio: 3 / 2 },
  hotelGalleryLarge: { width: 800, height: 400, note: 'Grande image galerie', ratio: 2 / 1 },
  hotelGalleryThumb: { width: 400, height: 200, note: 'Vignettes galerie', ratio: 2 / 1 },
  hotelCover: { width: 1200, height: 800, note: 'Image de couverture hôtel', ratio: 3 / 2 },
  pageHero: { width: 1920, height: 600, note: 'Hero page — min. 1200 px de large', ratio: 16 / 5 },
  cmsService: { width: 800, height: 600, note: 'Image service CMS', ratio: 4 / 3 },
  facility: { width: 600, height: 400, note: 'Image facility', ratio: 3 / 2 },
  userAvatar: { width: 400, height: 400, note: 'Avatar — format carré', ratio: 1 },
  footerBackground: { width: 1920, height: 600, note: 'Image de fond footer', ratio: 16 / 5 },
  headerImage: { width: 1920, height: 400, note: 'Image header', ratio: 24 / 5 },
  aboutSection: { width: 1000, height: 700, note: 'Image section about', ratio: 10 / 7 },
}

export const getImageDimensions = (key: ImageEntityKey): ImageDimension => {
  return IMAGE_DIMENSIONS[key] || { width: 0, height: 0 }
}
